<template lang="pug">
  .d-flex.flex-column.gap-12(v-if="!$conf.isVrn")
    dv-btn.full-width(
      v-for="(service, idx) in authServices"
      :key="idx"
      outlined
      text
      color="ui-neutral"
      :height="44"
      @click="service.click"
    )
      template(v-if="service.icon")
        v-icon.mr-2(:size="20" :color="service.color") {{ service.icon }}
      template(v-else-if="service.badge")
        v-avatar.mr-2(size="20" :color="service.badge.bg")
          span.text-caption.font-weight-bold(:class="service.badge.textClass") {{ service.badge.text }}
      p Войти через {{ service.text }}
    portal(v-if="dialogId" :to="`${dialogId}.content`" v-slot="{ close }")
      auth-max-form(
        @close="close"
        v-on="$listeners"
      )
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import AuthMaxForm from '../Forms/AuthMaxForm.vue';

export default {
  components: {
    DvBtn,
    AuthMaxForm,
  },
  props: {},
  data() {
    return {
      dialogId: undefined,
    };
  },
  computed: {
    authServices() {
      return [
        {
          icon: '$ui-vk',
          color: '#0077FF',
          text: 'Вконтакте',
          click: () => this.simpleAuthRedirect(this.$rApi.user.getSimpleAuthUriVk),
        },
        {
          text: 'Яндекс',
          color: '#F8604A',
          icon: '$ui-yandex',
          click: () => this.simpleAuthRedirect(this.$rApi.user.getSimpleAuthUriYandex),
        },
        {
          icon: '$ui-max',
          text: 'Max',
          color: '#8b00ff',
          click: this.openMaxFormDialog,
        },
        // {
        //   icon: '$ui-tg',
        //   text: 'Telegram',
        //   color: '#229ED9',
        //   // click: () => this.simpleAuthRedirect(this.$rApi.user.getSimpleAuthUriTg),
        //   click: this.openTgBlockDialog,
        // },
      ];
    },
  },
  methods: {
    simpleAuthRedirect(method) {
      const { path } = this.$route;
      if (!path.startsWith('/login') && !path.startsWith('/register')) {
        localStorage.setItem('redirect', path);
      }
      method().then(({ response }) => {
        const { uri, url } = response.data.data;
        if (uri || url) {
          window.location.href = uri || url;
        }
      });
    },
    openTgBlockDialog() {
      this.$dialogs.confirm({
        attrs: {
          method: () => {},
          title: 'Вход через сторонний сервис',
          message: `В связи с вступлением в силу положений российского законодательства
            о запрете авторизации через сервисы аутентификации, принадлежащие иностранцам, возможность входа через телеграмм ограничена
            до возвращения Павла Дурова в Российское гражданство. Если вы активно пользовались учётной записью, вход в которую осуществлялся
            только через телеграмм - рекомендуем авторизоваться через VK. Если ваши данные будут идентичны, вы сможете связать аккаунты`,
          messageAttrs: {
            class: 'text-justify',
          },
          closeBtnAttrs: {
            class: 'd-none',
          },
          confirmBtnAttrs: {
            class: 'mx-auto px-12 fit-content-width',
            'btn-text': 'Понятно',
          },
        },
      });
    },
    openMaxFormDialog() {
      this.dialogId = this.$dialogs.portal({
        attrs: {
          'max-width': 600,
          title: 'Вход в систему через Max',
          hideActions: true,
          persistent: true,
        },
        listeners: {
          'before:close': () => {
            this.dialogId = undefined;
          },
        },
      });
    },
  },
};
</script>
